import React from "react";
import { useApp } from "../../contexts";

export const ItemReady = ({ value, ...props }) => {
  const { T, language } = useApp();
  const {
    isLoading,
    className,
    title,
    description,
    actionBtn,
    actionBtnRight,
    isShowBtn,
  } = props;

  return (
    <div className={`w-full ${className}`}>
      <div
        className="text-white font-semibold text-[24px]/[30px] xl:text-[37px]/[50px] w-[200px] lg:w-[300px] xl:w-[550px] md:w-[250px] drop-shadow"
        dangerouslySetInnerHTML={{
          __html: T(title),
        }}
      ></div>
      <div
        className={`w-full text-white ${(language === 'pt' || language === 'es') ? 'text-[12px]/[18px] sm:text-[14px]/[20px] pr-4' : 'text-[14px]/[20px]'} font-semibold item-desrciption drop-shadow`}
        dangerouslySetInnerHTML={{
          __html: T(description),
        }}
      ></div>
      <div
        className={`grid grid-cols-2 gap-2 lg:gap-6 lg:mt-[20px] xl:mt-[30px] sm:mt-[15px] xs:mt-2 lis-action-ready drop-shadow`}
      >
        <button className="explore-earner-btn hover:text-aia-red transition-colors duration-200" onClick={actionBtn}>
          {T("Explore your Art")}
        </button>
        {isShowBtn && (
          <button
            className="earn-big-btn"
            onClick={actionBtnRight}
            disabled={isLoading}
          >
            {T("Create Wallet")}
          </button>
        )}
      </div>
    </div>
  );
};
